<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧社区</h2>
        <h3>智慧商超方案</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <div>
          <h2>智慧商超方案</h2>
          <p>近年来我国连锁商超行业发展迅速，连锁门店数量快速扩充，O2O模式正在催 生连锁行业的新变革，无论 是餐饮行业还是品牌服饰等行业，均遭受线上商 业模式的挑战和压力，面对严峻的市场竞争格局，传统商超都 在改变思维观 念，探索更加高效的运营模式，希望通过数字化手段，提高用户体验，降低 成本投入，增加品牌效应。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScwisdomBusinessSuper',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
</style>
